/**
 * React Query hooks for the "Explore More Areas" homepage module.
 * Fetches nearby areas for the Explore More Areas module.
 */

import { useQuery } from '@zg-rentals/react-query5';
import { area } from '@/src/lib/api/endpoints/area';
import type { NearbyArea } from '@/src/lib/api/endpoints/area';

export const exploreAreaKeys = {
  all: ['exploreAreas'] as const,
  nearby: (resourceId: string) => [...exploreAreaKeys.all, 'nearby', resourceId] as const,
};

export function useNearbyAreas(resourceId: string | undefined) {
  return useQuery<Array<NearbyArea>>({
    queryKey: exploreAreaKeys.nearby(resourceId ?? ''),
    queryFn: async () => {
      if (!resourceId) return [];
      const response = await area.nearby({ areaResourceId: resourceId, type: 'city', limit: 7 });
      return response.areas ?? [];
    },
    enabled: !!resourceId,
    staleTime: 10 * 60 * 1000,
  });
}
